import React from 'react';

import { ThemeType } from '../../../context/types';
import Icon from '../icon/Icon';
import { IconType } from '../icon/types';
import Spinner from '../spinner/Spinner';
import styles from './NavPlaceHolder.module.scss';

interface NavPlaceholderProps {
  mapLoading?: boolean;
  title: string;
  subtitle: string;
}
export const NavPlaceholder: React.FC<NavPlaceholderProps> = ({
  mapLoading,
  title,
  subtitle,
}) => (
  <div className={styles.placeholder}>
    {mapLoading ? (
      <Spinner iconSize={131} theme={ThemeType.PRIMARY} />
    ) : (
      <Icon size={131} icon={IconType.MAP_LOCATION} theme={ThemeType.PRIMARY} />
    )}
    <span className={styles.placeholderTitle}>{title}</span>
    <span className={styles.placeholderSubtitle}>{subtitle}</span>
  </div>
);
